var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31875 8.22125V12.0635C3.31875 12.3877 3.05356 12.6505 2.72935 12.6505C1.7781 12.6505 1 13.4216 1 14.3729C1 15.3295 1.7755 16.105 2.73212 16.105H18.3479C19.3045 16.105 20.08 15.3295 20.08 14.3729C20.08 13.4216 19.3019 12.6505 18.3506 12.6505C18.0264 12.6505 17.7612 12.3877 17.7612 12.0635V8.22125C17.7612 4.23306 14.5282 1 10.54 1C6.55181 1 3.31875 4.23307 3.31875 8.22125Z",
    stroke: "#1A2942",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7199 17.6951C13.7199 18.5385 13.3848 19.3473 12.7885 19.9437C12.1921 20.54 11.3833 20.8751 10.5399 20.8751C9.69648 20.8751 8.88763 20.54 8.29126 19.9437C7.6949 19.3473 7.35986 18.5385 7.35986 17.6951",
    stroke: "#1A2942",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.8970f8ce.svg";
export { ForwardRef as ReactComponent };